import { useCallback } from 'react';

interface CampaignData {
  previewRCS?: any;
  optionsExamples?: any;
}

const VARIABLE_REGEX = /{{\s*([\w\-]+)\s*}}/g;

const extractVariables = (input: any, variables: Set<string>) => {
  switch (true) {
    case typeof input === 'string':
      let match;
      while ((match = VARIABLE_REGEX.exec(input)) !== null) {
        variables.add(match[1]);
      }
      break;

    case Array.isArray(input):
      input.forEach((item: any) => extractVariables(item, variables));
      break;

    case input && typeof input === 'object':
      Object.values(input).forEach((val) => extractVariables(val, variables));
      break;
  }
};

const useDetectedVariables = () => {
  const detectedVariables = useCallback((data: CampaignData) => {
    if (!data?.previewRCS) return null;

    const variablesFound = new Set<string>();
    extractVariables(data.previewRCS.preview || [], variablesFound);

    const examples = data.optionsExamples || [];
    const missingVars = Array.from(variablesFound).filter(
      (variable) => !examples.some((example: any) => example.header === variable)
    );

    return missingVars.length > 0
      ? { error: 'variables_not_found', variables: missingVars }
      : { missingVars };
  }, []);

  return { detectedVariables };
};

export default useDetectedVariables;
